module.exports = __webpack_public_path__ + "static/media/followedDark.5e6c2ff3.svg";